export const stepOneData = [
  {
    heading: "Why Use MinEMI’s EMI Calculator for Bank of Baroda Home Loans?",
    // paras before heading
    paraOne:
      "Our calculator helps you make informed decisions by providing accurate estimates and useful insights into various loan options.",

    subOneList: [
      {
        head: "Accurate EMI Estimates: ",
        text: "Get precise monthly payment calculations based on your loan amount, interest rate, and tenure.",
      },
      {
        head: "Compare Loan Offers: ",
        text: "Evaluate EMIs across lenders to find the best deal that suits your budget.",
      },
      {
        head: "Understand Loan Affordability: ",
        text: "MinEMI helps you understand how much you can comfortably borrow without overburdening your finances.",
      },
      {
        head: "Explore Prepayment Options: ",
        text: "Calculate how partial prepayments can reduce your EMI or loan tenure.",
      },
      {
        head: "Plan for Future Goals: ",
        text: "Simulate different scenarios and make better financial plans for your home loan journey.",
      },
    ],

    tip: '"Choose the Right Tenure: A shorter tenure means higher EMIs but lower total interest. A longer tenure reduces EMIs but increases the overall interest paid. Balance your monthly budget and total interest cost by using the EMI calculator to test different tenure options."',
  },
];

export const stepTwoData = [
  {
    heading: "What You Can Do With the Home Loan EMI Calculator?",

    subOneList: [
      {
        head: "Estimate Monthly Payments: ",
        text: "Enter the loan amount, interest rate, and tenure to calculate your EMI instantly.",
      },
      {
        head: "Simulate Loan Scenarios: ",
        text: "Adjust variables like tenure or interest rates to understand their impact on your EMI.",
      },
      {
        head: "Plan Prepayments: ",
        text: "Use the calculator to evaluate how prepayments can reduce your interest burden or EMI.",
      },
    ],

    paraOne: "Sample EMI Calculation for Bank of Baroda Home Loans",

    tableContent: {
      heading: [
        {
          head: "Loan Amount",
        },
        {
          head: "Interest Rate (%)",
        },
        {
          head: "Tenure (Years)",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Total Interest (₹)",
        },
        {
          head: "Total Payment (₹)",
        },
      ],
      row: [
        {
          amount: "₹40,00,000",
          interest: "8.50%",
          tenure: "20	",
          emi: "₹34,803",
          tInterest: "₹43,52,720",
          payment: "₹83,52,720",
        },
        {
          amount: "₹50,00,000",
          interest: "8.25%",
          tenure: "15	",
          emi: "₹48,548",
          tInterest: "₹37,38,640",
          payment: "₹87,38,640",
        },
        {
          amount: "₹60,00,000",
          interest: "8.75%",
          tenure: "10",
          emi: "₹75,112",
          tInterest: "₹30,13,440",
          payment: "₹90,13,440",
        },
      ],
    },
    tip: '"Leverage Prepayment Opportunities: Make periodic lump-sum payments to reduce your loan tenure or EMI. Check with Bank of Baroda about prepayment penalties or charges. Use MinEMI’s prepayment calculator to see the impact on your loan."',
  },
];

export const stepThreeData = [
  {
    heading: "How to Maximize Savings on Your Bank of Baroda Home Loan EMI",

    subOneList: [
      {
        head: "Compare Interest Rates: ",
        text: "Evaluate interest rates from multiple lenders before applying. Even a 0.5% reduction in rates can lead to significant savings over the loan tenure.",
      },
      {
        head: "Opt for a Balance Transfer: ",
        text: "If your current loan has a high-interest rate, consider transferring it to Bank of Baroda for better terms. Use MinEMI’s Balance Transfer Calculator to estimate savings.",
      },
      {
        head: "Monitor Your Credit Score: ",
        text: "A high credit score ensures you qualify for lower interest rates. Regularly check your score and improve it by paying EMIs and credit card bills on time.",
      },
    ],
    tip: '"Account for Hidden Costs: Don’t forget about processing fees, legal charges, and property valuation costs. Include these costs in your loan calculations to avoid surprises. Use MinEMI’s calculators and guides to get a complete financial picture."',
  },
];

export const stepFourData = [
  {
    heading: "Understanding Bank of Baroda Home Loan Features",

    subOneList: [
      {
        head: "Flexible Repayment Options: ",
        text: "Choose from various repayment tenures ranging from 5 to 30 years.",
      },
      {
        head: "Competitive Interest Rates: ",
        text: "Enjoy competitive interest rates starting from 8.25% per annum.",
      },
      {
        head: "Pre-Approved Loans: ",
        text: "Get pre-approved home loan offers based on your credit profile and income.",
      },
      {
        head: "Top-Up Loans: ",
        text: "Avail additional funds over and above your existing home loan for renovations or other expenses.",
      },
    ],

    tip: '"Maximize Tax Benefits: Utilize the tax benefits available on home loans to reduce your overall tax liability. Consult a tax advisor to understand how you can save more."',
  },
];

export const stepFiveData = [
  {
    heading: "Tax Benefits on Home Loans",

    subOneList: [
      {
        head: "Section 80C: ",
        text: "Claim deductions up to ₹1.5 lakh on the principal repayment.",
      },
      {
        head: "Section 24: ",
        text: "Claim deductions up to ₹2 lakh on the interest paid.",
      },
      {
        head: "Joint Home Loans: ",
        text: "Both co-applicants can claim tax benefits, doubling your savings.",
      },
    ],
  },
];
